export default __webpack_public_path__ + "static/media/JosephUgwu.09cab71a.svg";